import React from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import ProtectedRoute from './components/ProtectedRoute'
import AppLayout from './components/AppLayout'
import Login from './pages/Login'
import Chatbot from './pages/Chatbot'
import Dashboard from './pages/Dashboard'

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Raíz → chatbot */}
          <Route path="/" element={<Navigate to="/chatbot" replace />} />

          {/* Login (público) */}
          <Route path="/login" element={<Login />} />

          {/* App protegida */}
          <Route element={
            <ProtectedRoute>
              <AppLayout />
            </ProtectedRoute>
          }>
            <Route path="/chatbot"   element={<Chatbot />}   />
            <Route path="/dashboard" element={<Dashboard />} />
          </Route>

          {/* Cualquier otra ruta → inicio */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  )
}
